var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94397 4.00002C9.32694 4.00247 9.65672 4.2722 9.73697 4.64859L12.1057 15.7594L14.2752 7.9777C14.3677 7.6459 14.6566 7.40754 14.9984 7.38102C15.3402 7.35449 15.6621 7.54546 15.8041 7.85906L17.1171 11.4872H21.1837C21.6345 11.4872 22 11.8546 22 12.3077C22 12.7609 21.6345 13.1283 21.1837 13.1283H16.5918C16.2719 13.1283 15.9815 12.9404 15.8489 12.6478L15.2443 11.3133L12.786 19.4009C12.6847 19.7643 12.3499 20.0113 11.9746 19.9996C11.5994 19.9879 11.2804 19.7204 11.2018 19.3514L8.91461 8.6232L8.20411 12.4899C8.11952 12.8633 7.78917 13.1283 7.40815 13.1283H2.81631C2.36547 13.1283 1.99998 12.7609 1.99998 12.3077C1.99998 11.8546 2.36547 11.4872 2.81631 11.4872H6.75679L8.1428 4.63836C8.22782 4.26303 8.56101 3.99756 8.94397 4.00002Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBeat);
export default __webpack_public_path__ + "static/media/ic-beat.eae3b6e6487728be90761441a1ca0fd1.svg";
export { ForwardRef as ReactComponent };